import script from "./productList.vue?vue&type=script&setup=true&lang=js"
export * from "./productList.vue?vue&type=script&setup=true&lang=js"

import "./productList.vue?vue&type=style&index=0&id=44396238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44396238"]])

export default __exports__